import { createFeatureSelector } from '@ngrx/store';

export const selectLeadDraftState = createFeatureSelector('leadDraft');
